import React, { Component } from 'react'
import { connect } from 'react-redux';

import { customSecondsElapsedForInterval } from '../actions/BehaviourDataActions'

class TimerForInterval extends Component {

    componentDidMount = () => {
        this.props.newIncrementer.map((obj, index) => {
            return clearInterval(this.props.newIncrementer[0]);
        })
        if (this.props.isStart) {
            this.props.customSecondsElapsedForInterval("mount")
        }
    }

    componentWillUnmount = () => {
        this.props.incrementer.map((obj, index) => {
            return clearInterval(this.props.incrementer[0]);
        })
        this.props.customSecondsElapsedForInterval("unmount")
    }

    getSeconds = () => {
        return ('0' + this.props.secondsElapsed % 60).slice(-2)
    }

    getMinutes = () => {
        return Math.floor(this.props.secondsElapsed / 60)
    }

    render() {
        return (
            <div>
                {this.getMinutes()}:{this.getSeconds()}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        isStart: state.patientRecordIntervalCustomReducer.isStart,
        secondsElapsed: state.patientRecordIntervalCustomReducer.secondsElapsed,
        incrementer: state.patientRecordIntervalCustomReducer.incrementer,
        newIncrementer: state.patientRecordIntervalCustomReducer.newIncrementer
    }
}

export default connect(mapStateToProps, {customSecondsElapsedForInterval})(TimerForInterval);




// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/BehaviorData/components/TimerForInterval.js